import { render, staticRenderFns } from "./SettleIng.vue?vue&type=template&id=4a4be746&scoped=true"
import script from "./SettleIng.vue?vue&type=script&lang=js"
export * from "./SettleIng.vue?vue&type=script&lang=js"
import style0 from "./SettleIng.vue?vue&type=style&index=0&id=4a4be746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4be746",
  null
  
)

export default component.exports